export default __webpack_public_path__ + "static/media/wood.1219b2d3.jpg";